import { USCurrency } from 'components/ReusableComponents/FormattedPrice'
import Chevron from 'features/RateCodes/Chevron'
import moment from 'moment'

import { directfulServiceNames } from '../EditPaymentPeriodDialog/constants'
import styles from '../Services.module.scss'

export const SubscriptionsRow = ({
  plan,
  planRate,
  isFlatMonthly = true,
  startDate,
  endDate
}) => {
  const isEnded = moment(endDate).isBefore(moment())
  const isActive = moment(startDate).isBefore(moment())
  const willStart = moment(startDate).isAfter(moment())

  if (isEnded) {
    return null
  }

  const tooltipContent = endDate
    ? `End date: ${moment(endDate).format('MMM D, YYYY')}`
    : 'No end date set'

  return (
    <div className={styles.row} data-tip={tooltipContent}>
      <div>
        <span className={styles.planName}>{directfulServiceNames?.[plan] || plan}</span>
        {isActive && (
          <p className={styles.startDate}>
            <span className={styles.active}>Active</span>
            &nbsp;since {moment(startDate).format('MMM D, YYYY')}
          </p>
        )}
        {willStart && (
          <p className={styles.startDate}>
            <span className={styles.active}>Will start</span> on{' '}
            {moment(startDate).format('MMM D, YYYY')}
          </p>
        )}
      </div>
      <span className={styles.planRate}>
        {isFlatMonthly ? <USCurrency>{planRate}</USCurrency> : <>%{planRate}</>}
      </span>
      <Chevron />
    </div>
  )
}
